<route-container
  *ngIf="chatbotUuid"
  [uid]="chatbotUuid + '-rag-context'"
>
  <loader-container
    [loader]="loader"
    [options]="{
      contentTemplate: preview
    }"
    (loaded)="chatbot = $event"
  ></loader-container>
</route-container>


<ng-template #preview>
  <div *ngIf="chatbot">
    <nav mat-tab-nav-bar [tabPanel]="tabPanel">
      <a mat-tab-link
         *ngFor="let t of tabs"
         (click)="setActiveMainTab(t)"
         [active]="activeTab == t">{{t}}</a>
    </nav>
    <mat-tab-nav-panel #tabPanel>
      <div class="pb-4">
        <div *ngIf="activeTab == 'Similarity Search'">
          <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
          <div [formGroup]="searchForm">
            <div class="row p-0 m-0">
              <div [ngClass]="'col-12 col-md-10 col-lg-11 m-0 p-0 pe-2'">
                <mat-form-field class="d-block m-0 p-0">
                  <mat-label>Key-phrase or sentence prompt</mat-label>
                  <input matInput type="text" formControlName="prompt" class="d-block">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2 col-lg-1 m-0 p-0">
                <button
                  mat-fab
                  color="primary"
                  class="me-2"
                  (click)="ragSearch()"
                  [disabled]="!searchForm.valid"
                >
                  <mat-icon>search</mat-icon>
                </button>
                <button
                  mat-fab
                  color="primary"
                  class=""
                  [routerLink]="['../../', chatbot.id, 'config']"
                >
                  <mat-icon>tune</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <error-panel [error]="error"></error-panel>
          <div *ngIf="searchResults" class="mt-4">
            <p class="text-center fw-light font-size-12">
              A total of <span class="fw-bold">{{searchResultsTotal}}</span> embeddings found across
              <span class="fw-bold">{{searchResults.length}}</span>
              {{searchResults.length == 1 ? 'variable' : 'variables'}}. Search took
              <uptime-view
                [ngClass]="'text-reset fw-bold'"
                [seconds]="searchDuration"></uptime-view>
            </p>
            <nav mat-tab-nav-bar [tabPanel]="searchResultsPanel">
              <a mat-tab-link
                 *ngFor="let si of searchResults"
                 (click)="selectSearchResultTab(si.collection)"
                 [active]="searchResultTab == si.collection">{{si.collection}} ({{si.matches.length}})</a>
            </nav>
            <mat-tab-nav-panel #searchResultsPanel>
              <data-table
                *ngIf="searchResultsActive && searchResultsActive.matches.length"
                [items]="searchResultsActive.matches"
                [options]="{
                tableNgClass: 'text-secondary font-monospace font-size-12'
              }"
                [columnOptions]="{
                '$$raw': { hidden: true },
                'distance': { heading: 'Distance', order: 3, outerNgClass: 'text-primary' },
                'id': { heading: 'Id', order: 1, valueNgClass: 'text-secondary fw-light' },
                'entity': { heading: 'Entity Match', order: 2, renderTemplate: cellSearchResult }
              }"
              ></data-table>
              <div
                *ngIf="!searchResultsActive || !searchResultsActive.matches.length"
                class="alert alert-info"
              >
                No matches found in variable <b>{{searchResultTab}}</b>
              </div>
            </mat-tab-nav-panel>
          </div>
        </div>
        <div *ngIf="activeTab == 'Variables'">
          <p class="fw-light pt-4 px-3">
            The following is the set of RAG variables recognized by the <span class="fw-bold">{{chatbot.name}}</span>
            bot. These are used as RAG context during user prompts, unless explicitly disabled in the chatbot
            <a class="link-underline-light" [routerLink]="['../../', chatbot.id, 'config']">configuration</a> panel.
            Each variable represents a category of data / knowledge, persisted as RAG embedding records.
          </p>
          <div class="row m-0 p-0 my-2">
            <div *ngFor="let v of chatbot.contextVars"
              class="col-12 col-md-4 col-lg-3 m-0 p-0 pe-2">
              <mat-card class="d-block height-250">
                <mat-card-header>
                  <mat-card-title>
                    <a class="link-underline-light" [routerLink]="['./', v]">{{v}}</a>
                  </mat-card-title>
                  <mat-card-subtitle class="fw-light">
                    <ng-container [ngSwitch]="chatbot.settings.ragSearch[v].disabled">
                      <span *ngSwitchCase="true" class="text-danger fw-bold">**DISABLED**</span>
                      <span *ngSwitchCase="false">Enabled</span>
                    </ng-container>
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div class="pt-4 font-size-14">
                    Properties
                    <ul class="pt-2 fw-light">
                      <li>
                        Limit:
                        <span class="text-secondary">{{chatbot.settings.ragSearch[v].searchConfig.limit}}</span>
                      </li>
                      <li>
                        Metric:
                        <span class="text-secondary">{{chatbot.settings.ragSearch[v].searchConfig.metric_type}}</span>
                      </li>
                      <li>
                        Output Fields:
                        <span class="text-secondary">{{chatbot.settings.ragSearch[v].searchConfig.output_fields}}</span>
                      </li>
                    </ul>
                  </div>
                </mat-card-content>
                <mat-card-footer>
                  <actions-container [ngClass]="'pe-2'">
                    <button
                      [routerLink]="['./', v]"
                      [queryParams]="{ tab: 'Schema' }"
                      mat-raised-button>
                      <mat-icon>schema</mat-icon>
                      Schema</button>
                  </actions-container>
                </mat-card-footer>
              </mat-card>
            </div>
          </div>
          <actions-container *ngIf="!hideActions" [ngClass]="'mx-2'">
            <back-button></back-button>
            <button mat-raised-button color="primary"
                    [routerLink]="['../config']">
              <mat-icon class="valign-middle">tune</mat-icon> Change Settings
            </button>
          </actions-container>
        </div>
      </div>
    </mat-tab-nav-panel>
  </div>
</ng-template>

<ng-template #cellSearchResult let-cellItem=cellItem>
  <div class="text-secondary fw-light">
    {{cellItem['text']}}
  </div>
</ng-template>
